/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 31.10.17.
 */

import BaseValidator from "./BaseValidator";
import {t} from "../../../../trans";

class RequiredValidator extends BaseValidator {
    validate(value) {
        let required = this.schema.getRequired();
        if (!required) return null;
        let errors = {};
        let isError = false;
        for (let field of required) {
            if (value[field] == null || value[field] === "") {
                isError = true;
                errors[field] = t("value is required");
            }
        }
        if (isError) return errors;
        return null;
    }
}

export default RequiredValidator;
